import DailyReport from './daily-report';

export default DailyReport;
